import { render, staticRenderFns } from "./background-picker.vue?vue&type=template&id=56ab7fe2"
import script from "./background-picker.vue?vue&type=script&lang=js"
export * from "./background-picker.vue?vue&type=script&lang=js"
import style0 from "./background-picker.vue?vue&type=style&index=0&id=56ab7fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports